<mat-button-toggle
  class="custom-toggle flex items-center justify-center !bg-transparent !shadow-none border-none"
  (click)="toggleTheme()"
  disableRipple
>
  <mat-icon>{{ config.scheme === 'light' ? 'nights_stay' : 'wb_sunny' }}</mat-icon>
</mat-button-toggle>